import { ElaborationDocumentFilterEntity, TipoTipologicaEntity } from "src/app/document-management/models/elaboration-doc-filter";


export function createParteEntity(key: string, value: any): ElaborationDocumentFilterEntity[] {
  let parteLegaleAssociato = [];

  if(value.tipo === null || value.tipo === '') {
    let soggettiTerzi: ElaborationDocumentFilterEntity = {
      uri: "PDA" + (value.codiceFiscale ? "_" + value.codiceFiscale : ""),
      valore: setEntityValue(value.nome, value.cognome) + setEntityValueWithCategory(null),
      tipoEntita: setTypeEntity('soggettiterzi')
    }
    parteLegaleAssociato.push(soggettiTerzi);

    let parte: ElaborationDocumentFilterEntity = {
      uri: "PDA" + (value.codiceFiscale ? "_" + value.codiceFiscale : ""),
      valore: setEntityValue(value.nome, value.cognome) + setEntityValueWithCategory(null),
      tipoEntita: setTypeEntity(key)
    }
    parteLegaleAssociato.push(parte);
  } else if(value.tipo === 'IP' || value.tipo === 'CC'){// soggetti terzi
    let parte : ElaborationDocumentFilterEntity = {
      uri : "PDA" + (value.codiceFiscale ? "_" + value.codiceFiscale : ""),
      valore : setEntityValue(value.nome,value.cognome) + setEntityValueWithCategory(value.tipo),
      tipoEntita: setTypeEntity('soggettiterzi')
    }
    parteLegaleAssociato.push(parte);
  } else {//parti principali
    let parte : ElaborationDocumentFilterEntity = {
      uri : "PDA" + (value.codiceFiscale ? "_" + value.codiceFiscale : ""),
      valore: setEntityValue(value.nome, value.cognome) + setEntityValueWithCategory(value.tipo),
      tipoEntita: setTypeEntity(key)
    }
    parteLegaleAssociato.push(parte);
  }
  if(value.avvocato && value.avvocato.length > 0){//avvocati parti come soggetti terzi
    let legaleAssociato : ElaborationDocumentFilterEntity = {
      uri : "PDA" + (value.cfAvvocato ? "_" + value.cfAvvocato: ""),
      valore: value.avvocato ? value.avvocato + " categoria: LEGALE DI CONTROPARTE tipoSoggetto: -" : "",
      tipoEntita: setTypeEntity("legale")
    }
    parteLegaleAssociato.push(legaleAssociato)
  }



  return parteLegaleAssociato;
}

export function setTypeEntity(key: string): TipoTipologicaEntity{
  let tipoEntity:  TipoTipologicaEntity = {
    label_key: mapLabelKey(key),
    tipo: mapTypeKey(mapLabelKey(key)),
    id: "",
    rimosso: false,
    descrizione: "",
    label: ""
  }
  return tipoEntity

}

export function createEntity(key: string, value: any): ElaborationDocumentFilterEntity{
  let consultationFilter : ElaborationDocumentFilterEntity = {
    uri: "",
    valore : value,
    tipoEntita: setTypeEntity(key)
  }
  return consultationFilter;
}

export function setEntityValue(nome: string, cognome: string): string{
  return nome ? "nome: " + nome + (cognome ? " cognome: " + cognome : "-") : "ragioneSociale: " + (cognome ? cognome : "-")
}

export function setEntityValueWithCategory(tipo: string): string {
  let categoria = getCategoryFromType(tipo);
  let tipoSoggetto = getSubjectTypeFromType(tipo);

  return " categoria: " + (categoria ? categoria : "-") + " tipoSoggetto: " + (tipoSoggetto ? tipoSoggetto : "-");
}

function getCategoryFromType(tipo: string): string {
  if(tipo == null) {
    return null;
  }
  switch(tipo.toUpperCase()) {
    case 'AP':
    case 'AS':
      return 'ATTORE';
    case 'CC':
      return 'TERZO CHIAMATO';
    case 'IP':
      return 'INTERVENUTO';
    default:
      return null;
  }
}

function getSubjectTypeFromType(tipo: string): string {
  if (tipo == null) {
    return null;
  }
  switch (tipo.toUpperCase()) {
    case 'AP':
    case 'AS':
      return 'ATTORE';
    case 'CP':
      return 'CONVENUTO';
    default:
      return null;
  }
}

export function mapLabelKey(value: string){
  switch(value.toLowerCase()){
    case 'giudice':
      return 'judge';
    case 'dataultimamodifica':
      return 'DATA'
    case 'dataudienza':
      return 'DATA'
    case 'sezione':
      return 'court_section'
    case 'parti':
      return 'principal_actor'
    case 'convenutoprincipale':
      return 'defendant'
    case 'legale':
      return 'legal_principal_actor'
    case 'soggettiterzi':
      return 'other_counter_parts'
    default:
     return ''
  }
}

export function mapTypeKey(value: string){
  switch(value){
    case 'PERSONA':
      return 'entity';
    case 'PERSONA_LEGALE' :
      return 'entity'
    case 'AUT_GIUDIZIARIA':
      return 'entity'
    case 'DATA':
      return 'entity'
    default:
     return 'metadata'
  }
}

